const hy = {
  genderTxt: 'Gender',
  gender: 'Male',
  ageTxt: 'Age',
  heightTxt: 'Height',
  weightTxt: 'Weight',
  occupationTxt: 'Occupation',
};

export default hy;
